module.exports = __webpack_public_path__ + "static/media/computerscience.f6a0e998.webp";